module.exports = __webpack_public_path__ + "img/s-Imoo-img-4.945f9c24.png";